import React from 'react';
import { NavLink } from 'react-router-dom';

import './sidenav_links.css'

export const SectionLink = ({onClick, to, children}) => {
       
    return (
        <NavLink onClick={onClick} className="sidenavlinkDiv__sectionLink" activeClassName='sidenavlinkDiv__sectionLink--selected' to={to}>{children}</NavLink>
    )
}

export const SubsectionLink = ({ to, children, onClick }) => {
    return (
        <NavLink onClick={onClick} className='sidenavlinkDiv__subsectionLink' activeClassName='sidenavlinkDiv__subsectionLink--selected' to={to}>{children}</NavLink>
    )
}
